<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { queryString } from '@/utils';
import { mapMutations } from 'vuex';

export default {
	name: 'app',
	created() {
		// console.log('href', window.location.href);
		const query = queryString(window.location.href);
		this.getQuery(query);
	},
	methods: {
		...mapMutations({
			getQuery: 'GET_QUERY'
		})
	}
};
</script>

<style lang="scss">
#app {
	width: 100%;
	height: 100%;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
